module.exports = __webpack_public_path__ + "static/media/lionessScreen.bb4020d0.jpg";